import { render, staticRenderFns } from "./UserPopover.vue?vue&type=template&id=d217ff44&scoped=true"
import script from "./UserPopover.vue?vue&type=script&lang=js"
export * from "./UserPopover.vue?vue&type=script&lang=js"
import style0 from "./UserPopover.vue?vue&type=style&index=0&id=d217ff44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d217ff44",
  null
  
)

export default component.exports